import { render, staticRenderFns } from "./CaseExplorerTabs.vue?vue&type=template&id=01018b96"
import script from "./CaseExplorerTabs.vue?vue&type=script&lang=js"
export * from "./CaseExplorerTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports